import React, { useEffect, useState } from 'react'
import Paper from '@mui/material/Paper';
import useReport from './useReport'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { formatAmount } from '../../utils/formatAmount';
import { useSearchParams } from 'react-router-dom';
import { formatDate } from '../../utils/dateUtils';

const AmountSummaryReport = ({ startDate, endDate, groupBy }) => { 
  
  const {reportData, isLoading, getAmountSummaryReport} = useReport()
  const [rowData, setRowData] = useState([])

  useEffect(() => {
    setRowData(reportData)
  }, [reportData])

  useEffect(() => {
    getAmountSummaryReport({ startDate, endDate, groupBy })
    console.log('re-render')
  },[startDate, endDate, groupBy])

  if (isLoading) return <div>Loading report...</div>;

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 540 }}>
        <Table aria-label="sticky table">
          <TableHead stickyHeader style={{ backgroundColor: '#4e46e5' , color:'white'}}>
            <TableRow >
              <TableCell style={{ color:'white', fontWeight:'bold'}}>Order Date</TableCell>
              <TableCell style={{ color:'white', fontWeight:'bold'}}>Customer Count</TableCell>
              <TableCell style={{ color:'white', fontWeight:'bold'}}>Order Count</TableCell>
              <TableCell style={{ color:'white', fontWeight:'bold'}}>Total Amount (Paid %)</TableCell>
              <TableCell style={{ color:'white', fontWeight:'bold'}}>Avg Amount/Order</TableCell>
              <TableCell style={{ color:'white', fontWeight:'bold'}}>Cancelled Amount (Yen)</TableCell>
              <TableCell style={{ color:'white', fontWeight:'bold'}}>Down Profit THB</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rowData && rowData
              .map((row) => {
                return (
                  <TableRow tabIndex={-1} key={row.formattedDate}>
                    <TableCell>{formatDate(row.formattedDate)}</TableCell>
                    <TableCell>{row.customerCount}</TableCell>
                    <TableCell>{row.orderCount}</TableCell>
                    <TableCell>{`${formatAmount(row.totalAmount)} (${formatAmount(row.paidAmount/row.totalAmount*100)}%)`}</TableCell>
                    <TableCell>{`${formatAmount(row.totalAmount/row.orderCount)}`}</TableCell>
                    <TableCell>{formatAmount(row.cancelledAmount)}</TableCell>
                    <TableCell>{formatAmount(row.downProfitTh)}</TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}

export default AmountSummaryReport